import {gql} from "@irati/utils/gql"

import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import fullTeam from "../fragments/fullTeamV4"

const query = gql`
  query teamsPaginated(
    $businessId: ID!
    $teamName: String
    $limit: Int
    $searchAfter: String
    $state: TeamState
    $featureFlags: [String]
    $hasBranding: Boolean
    $hasManager: Boolean
  ) {
    teamsPaginated(
      businessId: $businessId
      teamName: $teamName
      limit: $limit
      searchAfter: $searchAfter
      state: $state
      featureFlags: $featureFlags
      hasBranding: $hasBranding
      hasManager: $hasManager
    ) {
      teams {
        ...fullTeam
        users(enabled: true, totalOnly: true) {
          total
        }
        managers(enabled: true, totalOnly: true) {
          total
        }
      }
      searchAfter
      searchData {
        total
      }
    }
  }
  ${fullTeam}
`

export const teamsPaginatedKey = getQueryNames(query)[0]

export default query
